import { useState } from 'react'
import { MessageSquarePlus } from 'lucide-react'
import { Button } from '@/components/play'
import { FeedbackCreateModal } from '@/components/feedback/FeedbackCreateModal'

export function FeedbackFloatingButton() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button elevated onClick={() => setOpen(true)} className="fixed bottom-5 right-4 z-40 sm:bottom-8 sm:right-8">
        <MessageSquarePlus aria-hidden="true" />
        Feedback
      </Button>
      <FeedbackCreateModal open={open} onOpenChange={setOpen} />
    </>
  )
}
